import {setPassengerDataUpdating, setTicket} from "@CheckOrder/reducers/checkOrderSlice";
import {OnQueryStartedFunctionAttrType} from "@/types/generic/OnQueryStartedFunctionAttr.type";
import {RemoveVoucherRequestType, RemoveVoucherResponseType} from "@CheckOrder/api/types/vouchers/RemoveVoucher.type";
import {setError} from "@Reducers/pageSlice";

export default function removeVoucherQuery(): OnQueryStartedFunctionAttrType<RemoveVoucherRequestType, RemoveVoucherResponseType> {
    return async (request, {dispatch, queryFulfilled}) => {
        dispatch(setPassengerDataUpdating(true))

        try {
            const response = await queryFulfilled

            if (response.meta.response.ok && !!response.data.ticket) {
                dispatch(setTicket({ticket: {
                        ...request.ticket,
                        ...response.data.ticket,
                    },
                    keepPassengerClasses: true,
                }))

                dispatch(setPassengerDataUpdating(false))
            }
        } catch (err) {
            dispatch(setError({
                error: "Voucher couldn't be removed",
                info: `Voucher couldn't be removed from ticket: ${request.ticket_code}`,
            }))
            dispatch(setPassengerDataUpdating(false))
        }
    }
}